import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import contentReducer from './contentSlice';
import walletReducer from './walletSlice';
import paymentReducer from './paymentSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    content: contentReducer,
    wallet: walletReducer,
    payment: paymentReducer
  }
});

export default store;
